import { SyncManager } from '@/lib/sync-manager/dexie-sync-manager.ts'
import { createCommittentiSyncable } from '@/features/committenti/committenti-sync.ts'
import { createFotoInterventiSyncable } from '@/features/foto-interventi/foto-interventi-sync.ts'
import { createInterventiSyncable } from '@/features/interventi/interventi-sync.ts'
import { createUtentiSyncable } from '@/features/utenti/utenti-sync'
import type { DexieDatabase } from './local/dexie-db'

export function createSyncManager(db: DexieDatabase): SyncManager {
  const syncManager = new SyncManager([
    createUtentiSyncable(db),
    createCommittentiSyncable(db),
    createInterventiSyncable(db),
    createFotoInterventiSyncable(db),
  ])

  if (typeof window !== 'undefined') {
    // @ts-expect-error debugging
    window.syncManager = syncManager
  }

  return syncManager
}
